import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { useSettingsStore } from 'src/store/settings-store';
import { createCustomTheme } from 'src/theme';
import { LocalizationProvider } from './localization-provider';
import { ToastSuccessIcon } from 'src/icons/toast-success-icon';
import { ToastErrorIcon } from 'src/icons/toast-error-icon';
import { TotpDialogProvider } from 'src/containers/contexts/totp-dialog-provider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

export const Providers = ({ children }: { children: ReactNode }) => {
  const settingsDirection = useSettingsStore(state => state.direction);
  const settingsTheme = useSettingsStore(state => state.theme);

  const theme = createCustomTheme({
    direction: settingsDirection,
    theme: settingsTheme,
  });

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <LocalizationProvider>
            <TotpDialogProvider>{children}</TotpDialogProvider>
          </LocalizationProvider>
          <Toaster
            position="top-center"
            containerStyle={{}}
            toastOptions={{
              style: {
                wordBreak: 'break-word',
                borderRadius: '2px',
                paddingTop: '7px',
                paddingRight: '17px',
                paddingBottom: '7px',
                paddingLeft: '17px',
                gap: '10px',
                boxShadow: '2px 2px 8px 0px #00000026',
                fontSize: '16px',
              },
              success: {
                icon: <ToastSuccessIcon />,
              },
              error: {
                icon: <ToastErrorIcon />,
              },
            }}
          />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
};
